import React from 'react';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { buildKey, noop } from '@yme/common/index';
import { colorCoreBlack900Base, defaultTransparent } from '@yme/tokens/colors';
import { getOrder } from './helpers';
import { MiniButtonContent, MiniButtonStyled } from './styled';
export function MiniButton(props) {
    const { bgStyle = defaultTransparent, contentColor = colorCoreBlack900Base, isPaddingsReset = false, iconType = undefined, isFirstIcon = false, isRightToLeft = false, isInteractive = true, isUnderlined = false, isDisabled = false, iconRotate = undefined, iconSize = ICON_SIZE.s, tabIndex = 0, children, title = '', onClick = noop, className, type = 'button', dataTestId = '', as, } = props;
    const dataTestIdMiniButton = buildKey(dataTestId, 'mini-button');
    return (React.createElement(MiniButtonStyled, { bgStyle: bgStyle, isPaddingsReset: isPaddingsReset, contentColor: contentColor, onClick: onClick, isInteractive: isInteractive, isUnderlined: isUnderlined, className: className, title: title, "aria-label": title, tabIndex: tabIndex, disabled: isDisabled, type: type, "data-testid": dataTestIdMiniButton, as: as },
        iconType && (React.createElement(SVGIcon, { type: iconType, order: getOrder({
                isFirstIcon,
                isRightToLeft,
            }), iconRotate: iconRotate, size: iconSize })),
        children && (React.createElement(MiniButtonContent, { order: getOrder({
                isFirstIcon: !isFirstIcon,
                isRightToLeft,
            }) }, children))));
}
MiniButton.displayName = 'MiniButton_Component';
